<template>
  <div id="datatable" class="table_wrapper" :class="[propsObj.itemLabel && reportFilterObj && Object.keys(reportFilterObj).length ? 'four-lines-header' : !propsObj.itemLabel && (!reportFilterObj || (reportFilterObj && !Object.keys(reportFilterObj).length)) ? 'two-lines-header' : '']">

        <div class="reportdetails">
          <!-- <h3 class="body-2" v-if="$root.CurrentBusiness">{{$root.CurrentBusiness.BusinessName}}</h3> -->
          <!-- <h3 class="body-2" v-if="$root.CurrentBusiness">{{propsObj.reportTitle}}</h3> -->

          <p class="caption" v-if="propsObj.itemLabel" v-ripple @click="openDialogAndroid">
            <span class="font-medium">
              {{propsObj.itemLabel}}
            </span>: <span class="item-link">{{propsObj.itemName}}</span>
          </p>

          <p class="caption">
            
            <span @click="openDialogCustomDates" v-if="propsObj.periodLabel == 'Period'">
              <span class="font-medium">{{propsObj.periodLabel}}</span>: 
              <span class="item-link">{{propsObj.startDate | moment("DD-MMM-YYYY")}}</span> 
              <span class="item-link">To</span> 
              <span class="item-link">{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span>
            </span>

            <span @click="openDatePicker('end', propsObj.endDate)" v-else>
              <span class="font-medium">{{propsObj.periodLabel}}</span>: 
              <span class="item-link">{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span>
            </span>

            <!-- <span class="item-link" v-ripple @click="openDatePicker('start', propsObj.startDate)" v-if="propsObj.periodLabel == 'Period'">{{propsObj.startDate | moment("DD-MMM-YYYY")}}</span>
            <span v-if="propsObj.periodLabel=='Period'">To</span>
            <span class="item-link" v-ripple @click="openDatePicker('end', propsObj.endDate)">{{propsObj.endDate | moment("DD-MMM-YYYY")}}</span> -->

            <v-menu style="position:absolute;right:16px" v-if="propsObj.periodLabel == 'Period'">
                <v-btn justify-content-to-end style="height: 16px;" nomargin nopadding flat capitalize font-normal slot="activator">{{propsObj.selectedPeriod}}&nbsp;<v-icon font20>date_range</v-icon></v-btn>
                <v-list nopadding>
                  <v-list-tile v-for="(item, index) in periods" :key="'period'+index" @click="selectPeriod(item.value)">
                      <v-list-tile-title>{{item.title}}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
            </v-menu>

            <!-- <v-menu style="position:absolute;right:16px" v-if="$route.params.reportid == 109">
                <v-btn justify-content-to-end style="height: 16px;" nomargin nopadding flat capitalize font-normal slot="activator">{{propsObj.selectedPeriod ? propsObj.selectedPeriod : 'Custom'}}&nbsp;<v-icon font20>date_range</v-icon></v-btn>
                <v-list nopadding>
                  <v-list-tile v-for="(item, index) in periodsLastDays" :key="'period'+index" @click="selectDays(item)">
                      <v-list-tile-title>{{item.title}}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
            </v-menu> -->
          </p>

          <p class="caption" v-if="reportFilterObj && Object.keys(reportFilterObj).length">
            <span v-for="(filter, key, index) in reportFilterObj">
              <span class="font-medium">{{filter.name}}</span>: {{filter.value}}{{index!=Object.keys(reportFilterObj).length-1 ? ', ': ''}}
            </span>
          </p>
          
        </div>

        <template v-if="$route.params.reportid==205 || $route.params.reportid==310 || $route.params.reportid==311 || $route.params.reportid==312 || $route.params.reportid==418 || $route.params.reportid==419 || $route.params.reportid==420">
          <div v-if="propsObj.reportData" :class="{'fixed-width-table': propsObj.columns.length == 2 || propsObj.columns.length == 3, 'two-column': propsObj.columns.length == 2, 'three-column': propsObj.columns.length == 3}">
        
            <div class="header" id="tableHeader">
                <div class="table" full-width>
                    <div class="table_row">
                        <div class="table_col" v-for="(item, index) in propsObj.reportData.headerRow" :key="'header'+index" :class="{'right-align': item.type=='number'}">
                          {{ item.headerName ? item.headerName : '' }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="body" id="tableBody" v-if="propsObj.reportData && propsObj.reportData.detailRows" :class="{'three-row-card':propsObj.reportData.summaryRows && propsObj.reportData.summaryRows.length==3}">
                <div class="table" full-width>
                  <template v-for="(item, index) in propsObj.reportData.detailRows">

                    <div :key="item.transactionId || index">

                      <div class="table_row" @click="fn_getDetails(item)" :key="'table_row_'+index">
                        <div class="table_col" v-for="(col, colIndex) in propsObj.columns" :key="'rowcol'+colIndex" :class="{'right-align': typeof(item.cols[col])=='number'}">
                          <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'" :class="fn_getCustomDateClass(item, col)">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                          
                          <span :class="{'font-medium': fn_makeRowsColsStrong(item, col)}" v-else-if="$route.params.reportid == 601 || $route.params.reportid == 602 || $route.params.reportid == 603 || $route.params.reportid == 901">
                            <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                            <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                          </span>

                          <span :class="{'font-medium':item.mainRow}" v-else>
                            <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                            
                            <span v-else-if="$route.params.reportid==109">
                              <template v-if="col == 'expiredIn'">
                                {{item.cols[col] > 0 ? item.cols[col] : ''}}
                              </template>
                              <template v-else>
                                {{item.cols[col] ? item.cols[col] : ''}}
                              </template>
                            </span>
                            
                            <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                          </span>
                        </div>
                      </div>

                      <div class="table_row" v-if="item.subHeaders">
                        <template>
                          <div class="table_col">
                            <strong></strong>
                          </div>
                          <div class="table_col">
                            <strong>{{item.subHeaders.srNo}}</strong>
                          </div>
                          <div class="table_col">
                            <strong>{{item.subHeaders.productName}}</strong>
                          </div>
                          <div class="table_col" v-if="item.subHeaders.hsnCode">
                            <strong>{{item.subHeaders.hsnCode}}</strong>
                          </div>
                          <div class="table_col right-align">
                            <strong>{{item.subHeaders.qty}}</strong>
                          </div>
                          <div class="table_col">
                            <strong>{{item.subHeaders.unit}}</strong>
                          </div>
                          <div class="table_col right-align">
                            <strong>{{item.subHeaders.rate}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders.discount">
                            <strong>{{item.subHeaders.discount}}</strong>
                          </div>
                          <div class="table_col right-align">
                            <strong>{{item.subHeaders.taxableValue}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders.gstPercentage">
                            <strong>{{item.subHeaders.gstPercentage}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders.cgst">
                            <strong>{{item.subHeaders.cgst}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders.sgst">
                            <strong>{{item.subHeaders.sgst}}</strong>
                          </div>
                          <div class="table_col" v-if="item.subHeaders.utgst">
                            <strong>{{item.subHeaders.utgst}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders.igst">
                            <strong>{{item.subHeaders.igst}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders.cessPercentage">
                            <strong>{{item.subHeaders.cessPercentage}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders.cessOnQtyPercentage">
                            <strong>{{item.subHeaders.cessOnQtyPercentage}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders.cess">
                            <strong>{{item.subHeaders.cess}}</strong>
                          </div>
                          <div class="table_col right-align">
                            <strong>{{item.subHeaders.total}}</strong>
                          </div>
                        </template>
                      </div>

                      <template v-for="(detailItem, detailItemIndex) in item.cols.itemDetailRows">
                        <div class="table_row" v-if="item.cols.itemDetailRows && item.cols.itemDetailRows.length" @click="openTransaction(item.transactionListId, item.transactionId);">    
                          <!-- <div :key="detailItemIndex"> -->
                            <div class="table_col"></div>
                            <div class="table_col">{{detailItem.srNo}}</div>
                            <div class="table_col">{{detailItem.productName}}</div>
                            <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">{{detailItem.hsnCode}}</div>
                            <div class="table_col right-align">{{$root.numberToLocale(detailItem.qty)}}</div>
                            <div class="table_col">{{detailItem.unit}}</div>
                            <div class="table_col right-align">{{$root.numberToLocale(detailItem.rate)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">{{$root.numberToLocale(detailItem.discount)}}</div>
                            <div class="table_col right-align">{{$root.numberToLocale(detailItem.taxableValue)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">{{$root.numberToLocale(detailItem.gstPercentage)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">{{$root.numberToLocale(detailItem.cgst)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">{{$root.numberToLocale(detailItem.sgst)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">{{$root.numberToLocale(detailItem.utgst)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">{{$root.numberToLocale(detailItem.igst)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">{{$root.numberToLocale(detailItem.cessPercentage)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">{{$root.numberToLocale(detailItem.cessOnQtyPercentage)}}</div>
                            <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">{{$root.numberToLocale(detailItem.cess)}}</div>
                            <div class="table_col right-align">{{$root.numberToLocale(detailItem.total)}}</div>
                          <!-- </div> -->                    
                        </div>
                      </template>

                      <div class="table_row" v-if="item.cols.subTotal">
                        <template>
                          <div class="table_col"></div>
                          <div class="table_col">
                            <strong>{{item.cols.subTotal.srNo}}</strong>
                          </div>
                          <div class="table_col">
                            <strong>{{item.cols.subTotal.productName}}</strong>
                          </div>
                          <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                            <strong>{{item.cols.subTotal.hsnCode}}</strong>
                          </div>
                          <div class="table_col right-align">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.qty)}}</strong>
                          </div>
                          <div class="table_col">
                            <strong>{{item.cols.subTotal.unit}}</strong>
                          </div>
                          <div class="table_col right-align">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.rate)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.discount)}}</strong>
                          </div>
                          <div class="table_col right-align">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.taxableValue)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.gstPercentage)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.cgst)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.sgst)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.utgst)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.igst)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.cessPercentage)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.cessOnQtyPercentage)}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.cess)}}</strong>
                          </div>
                          <div class="table_col right-align">
                            <strong>{{$root.numberToLocale(item.cols.subTotal.total)}}</strong>
                          </div>
                        </template>
                        
                      </div>

                      <div class="table_row" v-if="item.cols.billAddOns">
                        <template>
                          <div class="table_col"></div>
                          <div class="table_col">                        
                          </div>
                          <div class="table_col">
                          </div>
                          <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                          </div>
                          <div class="table_col right-align">
                          </div>
                          <div class="table_col">
                          </div>
                          <div class="table_col right-align">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                          </div>
                          <div class="table_col right-align">
                            <strong>{{item.cols.billAddOns.srNo}}</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                          </div>
                          <div class="table_col right-align">
                            <strong>{{$root.numberToLocale(item.cols.billAddOns.total)}}</strong>
                          </div>
                        </template>
                        
                      </div>

                      <div class="table_row" v-if="item.cols.tdsAddOns">
                        <template>
                          <div class="table_col"></div>
                          <div class="table_col">                        
                          </div>
                          <div class="table_col">
                          </div>
                          <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                          </div>
                          <div class="table_col right-align">
                          </div>
                          <div class="table_col">
                          </div>
                          <div class="table_col right-align">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                          </div>
                          <div class="table_col right-align">
                            <strong>Total TDS</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                          </div>
                          <div class="table_col right-align">
                            <strong>{{$root.numberToLocale(item.cols.tdsAddOns.total)}}</strong>
                          </div>
                        </template>
                        
                      </div>

                      <div class="table_row" v-if="item.cols.total">
                        <template>
                          <div class="table_col"></div>
                          <div class="table_col">                        
                          </div>
                          <div class="table_col">
                          </div>
                          <div class="table_col" v-if="item.subHeaders && item.subHeaders.hsnCode">
                          </div>
                          <div class="table_col right-align">
                          </div>
                          <div class="table_col">
                          </div>
                          <div class="table_col right-align">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.discount">
                          </div>
                          <div class="table_col right-align">
                            <strong>Total</strong>
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.gstPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.sgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.utgst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.igst">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cessOnQtyPercentage">
                          </div>
                          <div class="table_col right-align" v-if="item.subHeaders && item.subHeaders.cess">
                          </div>
                          <div class="table_col right-align">
                            <strong>{{$root.numberToLocale(item.cols.total.total)}}</strong>
                          </div>
                        </template>
                        
                      </div>

                    </div>                    

                  </template>
                </div>
            </div>

            <div class="table footer-card" v-if="$route.params.reportid==501 || $route.params.reportid==502">
                <div class="table_row" v-for="(item, index) in propsObj.reportData.summaryRows">
                    <div class="table_col" v-for="(col, index) in propsObj.footerColumns" :key="'summaryrowcol'+index" 
                    :class="{'right-align': typeof(item[col])=='number'}">
                      <strong>
                          <span v-if="typeof(item[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item[col] ? $root.numberToLocale(item[col]) : ''}}</span>
                          <span v-else>{{item[col] ? item[col] : ''}}</span>
                      </strong>
                    </div>
                </div>
            </div>
            

            <div class="footer" id="tableFooter" v-if="propsObj.reportData.footerRow && $route.params.reportid!=501 && $route.params.reportid!=502">
                <div class="table" full-width>
                    <div class="table_row">
                        <div class="table_col" v-for="(col, index) in propsObj.columns" :key="'footerrowcol'+index" 
                        :class="{'right-align': typeof(propsObj.reportData.footerRow[col])=='number'}">
                            <strong>
                                <span v-if="typeof(propsObj.reportData.footerRow[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</span>
                                <span v-else>{{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}</span>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>

          </div>
        </template>

        <template v-else>
          <div v-if="propsObj.reportData" :class="{'fixed-width-table': propsObj.columns.length == 2 || propsObj.columns.length == 3, 'two-column': propsObj.columns.length == 2, 'three-column': propsObj.columns.length == 3}">
        
            <div class="header" id="tableHeader">
                <div class="table" full-width>
                    <div class="table_row">
                        <!-- <div class="table_col" v-for="(value, key) in propsObj.reportData.headerRow">{{value ? value : '-'}}</div> -->
                        <div class="table_col" v-for="(item, index) in propsObj.reportData.headerRow" :key="'header'+index" :class="{'right-align': item.type=='number'}">
                          {{ item.headerName ? item.headerName : '' }}
                          <!-- <template v-if="$route.params.reportid==201">
                            {{ item.headerName == 'To Receive' ? $root.fn_getDebitLabel() : item.headerName == 'To Pay' ? $root.fn_getCreditLabel() : item.headerName }}
                          </template>
                          <template v-else>
                            {{ item.headerName ? item.headerName : '' }}
                          </template> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="body" id="tableBody" v-if="propsObj.reportData && propsObj.reportData.detailRows" :class="{'three-row-card':propsObj.reportData.summaryRows && propsObj.reportData.summaryRows.length==3}">
                <div class="table" full-width>
                  <div class="table_row" v-for="(item, index) in propsObj.reportData.detailRows" @click="fn_getDetails(item)">
                    <!-- fn_isSubItems only for balance sheet -->
                     <!-- fn_leftPad only for balance sheet -->
                      <div class="table_col" v-for="(col, colIndex) in propsObj.columns" :key="'rowcol'+colIndex" :class="{'right-align': typeof(item.cols[col])=='number' && !fn_isSubItems(item, col, colIndex), 'pl-4':fn_leftPad(item, col, colIndex)}">
                        <!-- , 'small':item.cols[col]=='Dr' || item.cols[col]=='Cr' -->
                        <!-- <span v-if="propsObj.reportData.headerRow[col] == 'Date'">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span> -->
                        <span v-if="propsObj.reportData.headerRow[colIndex].type == 'date'" :class="fn_getCustomDateClass(item, col)">{{item.cols[col] | moment("DD-MMM-YYYY")}}</span>
                        <!-- <span :class="{'font-medium': ($route.params.reportid == 601 || $route.params.reportid == 602 || $route.params.reportid == 603 || $route.params.reportid == 901) && item.accountGroupId || item.mainRow}" v-else-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                        <span :class="{'font-medium': ($route.params.reportid == 601 || $route.params.reportid == 602 || $route.params.reportid == 603 || $route.params.reportid == 901) && item.accountGroupId || item.mainRow}" v-else>{{item.cols[col] ? item.cols[col] : ''}}</span> -->
                        <span :class="{'font-medium': fn_makeRowsColsStrong(item, col)}" v-else-if="$route.params.reportid == 601 || $route.params.reportid == 602 || $route.params.reportid == 603 || $route.params.reportid == 901">
                          <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                          <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                        </span>

                        <span :class="{'font-medium':item.mainRow}" v-else>
                          <span v-if="propsObj.reportData.headerRow[colIndex].type == 'number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item.cols[col] ? $root.numberToLocale(item.cols[col]) : ''}}</span>
                          
                          <span v-else-if="$route.params.reportid==109">
                            <template v-if="col == 'expiredIn'">
                              {{item.cols[col] > 0 ? item.cols[col] : ''}}
                            </template>
                            <template v-else>
                              {{item.cols[col] ? item.cols[col] : ''}}
                            </template>
                          </span>
                          
                          <span v-else>{{item.cols[col] ? item.cols[col] : ''}}</span>
                        </span>
                      </div>
                  </div>
                  <!-- <div class="endmsg">End of Report</div> -->
                </div>
            </div>

            <!-- <div class="body" id="tableBody">
                <div class="table">
                    <div class="table_row" v-for="(item, index) in propsObj.reportData.detailRows">
                        <div class="table_col" v-for="(value, key) in item.cols" :class="{'right-align': typeof(value)=='number', 'small':value=='Dr' || value=='Cr'}">
                          <span v-if="propsObj.reportData.headerRow[key] == 'Date'">{{value | moment("DD-MMM-YYYY")}}</span>
                          <span v-else>{{value}}</span>
                        </div>
                    </div>
                    <div class="endmsg">End of Report</div>
                </div>
            </div> -->
            <!-- v-if="Object.keys(propsObj.reportData.footerRow).length != 0" -->


            <div class="table footer-card" v-if="$route.params.reportid==501 || $route.params.reportid==502">
                <div class="table_row" v-for="(item, index) in propsObj.reportData.summaryRows">
                    <div class="table_col" v-for="(col, index) in propsObj.footerColumns" :key="'summaryrowcol'+index" 
                    :class="{'right-align': typeof(item[col])=='number'}">
                      <strong>
                          <span v-if="typeof(item[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{item[col] ? $root.numberToLocale(item[col]) : ''}}</span>
                          <span v-else>{{item[col] ? item[col] : ''}}</span>
                      </strong>
                    </div>
                </div>
            </div>
            

            <div class="footer" id="tableFooter" v-if="propsObj.reportData.footerRow && $route.params.reportid!=501 && $route.params.reportid!=502">
                <div class="table" full-width>
                    <div class="table_row">
                        <div class="table_col" v-for="(col, index) in propsObj.columns" :key="'footerrowcol'+index" 
                        :class="{'right-align': typeof(propsObj.reportData.footerRow[col])=='number'}">
                            <strong>
                                <span v-if="typeof(propsObj.reportData.footerRow[col])=='number' && (col != 'dqty' && col != 'qty' && col != 'inward' && col != 'outward' && col != 'voucherCount' && col != 'opening' && col != 'closing' && col != 'balance')">{{propsObj.reportData.footerRow[col] ? $root.numberToLocale(propsObj.reportData.footerRow[col]) : ''}}</span>
                                <span v-else>{{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}</span>

                                <!-- <span v-else>
                                  <template v-if="$route.params.reportid==201">
                                    {{ propsObj.reportData.footerRow[col] == 'To Receive' ? $root.fn_getDebitLabel() : propsObj.reportData.footerRow[col] == 'To Pay' ? $root.fn_getCreditLabel() : propsObj.reportData.footerRow[col] }}
                                  </template>
                                  <template v-else>
                                    {{propsObj.reportData.footerRow[col] ? propsObj.reportData.footerRow[col] : ''}}
                                  </template>
                                </span> -->
                            </strong>
                        </div>
                    </div>
                </div>
            </div>

            


            <!-- <div class="footer" id="tableFooter" v-if="propsObj.reportData.footerRow">
                <div class="table">
                    <div class="table_row">
                        <div class="table_col" v-for="(value, key) in propsObj.reportData.footerRow" :class="{'right-align': typeof(value)=='number', 'small':value=='Dr' || value=='Cr'}">{{value}}</div>
                    </div>
                </div>
            </div> -->

        </div>
        </template>

          <!-- <div style="padding-top:100px">
            {{propsObj}}
          </div> -->

          <!-- <div v-if="Item && !Item.detailRows.length && !error" class="display_msg">No record found.</div> -->
  </div>
</template>

<script>
const transactionForms = require('../../../config.js').configs.transactionForms;
  export default{
    props:['reportId', 'propsObj', 'openDialogAndroid', 'getReportItemDetails', 'openDatePicker', 'reportFilterObj', 'openTransaction', 'openAccountDetails', 'openLinkedAccount', 'getSubReportData', 'periods', 'selectPeriod', 'openDialogCustomDates', 'periodsLastDays', 'selectDays'],
    methods:{

      fn_makeRowsColsStrong: function(item, col){
        if((this.$route.params.reportid == 601 || this.$route.params.reportid == 901) && item.accountGroupId){
          return true;
        }
        else if(this.$route.params.reportid == 602 || this.$route.params.reportid == 603){
          if(!item.linkedAccounts){
            return true;
          }
          else if(item.linkedAccounts && item.linkedAccounts.length == 1){
            if(this.$route.params.reportid == 602){
              if((col == 'purchaseAccountName' || col == 'purchaseAmount') && !item.cols.purchaseAccountId){
                return true;
              }
              else if((col == 'saleAccountName' || col == 'saleAmount') && !item.cols.saleAccountId){
                return true;
              }
              else{
                return false;
              }
            }
            else{
              if((col == 'assetAccountName' || col == 'assetAmount') && !item.cols.assetAccountId){
                return true;
              }
              else if((col == 'liabilityAccountName' || col == 'liabilityAmount') && !item.cols.liabilityAccountId){
                return true;
              }
              else{
                return false;
              }
            }
            
          }
          else{
            return false;
          }
        }
        else{
          return false;
        }
      },

      fn_leftPad: function(item, col, colIndex){
        if(!this.fn_makeRowsColsStrong(item, col) && this.$route.params.reportid == 603 && (colIndex == 0 || colIndex == 2)){
          return true;
        }        
        else{
          return false;
        }
      },

      fn_isSubItems: function(item, col, colIndex){
        if(!this.fn_makeRowsColsStrong(item, col) && this.$route.params.reportid == 603 && (colIndex == 1 || colIndex == 3)){
          return true;
        }        
        else{
          return false;
        }
      },

      fn_getTransactionType: function(listId){
        for(let i=0; i<transactionForms.length; i++){
          if(transactionForms[i].id==listId){
            return transactionForms[i].title;
          }
        }
      },

      fn_getDetails: function(item, linkedAccount){
        console.log('testing');
        let self = this;
        setTimeout(function(){
          self.propsObj.disableClick = false;
        },300);
        
        if(this.propsObj.disableClick || (this.$route.params.reportid == 503 && item.cols.isGroup)){
          return;
        }
        
        this.propsObj.disableClick = true;
        let startDate = this.propsObj.startDate ? this.$moment(new Date(this.propsObj.startDate)).format('YYYY-MM-DD') : null;
        let endDate = this.$moment(new Date(this.propsObj.endDate)).format('YYYY-MM-DD');

        // if(this.propsObj.detailReportId && item.transactionId){
        if((this.$route.params.reportid == 602 || this.$route.params.reportid == 603) && !linkedAccount){
          this.openLinkedAccount(item.linkedAccounts);
        }
        else if(this.$route.params.reportid == 201){
          this.getReportItemDetails(item.transactionListId, item.transactionId);
        }
        else if(this.$route.params.reportid == 801 || this.$route.params.reportid == 802){
          this.getSubReportData(item.subReportId);
        }
        else if(this.propsObj.openView && item.transactionId && item.transactionListId){
          this.openTransaction(item.transactionListId, item.transactionId);
        }
        // else if(this.propsObj.openAccount){
        //   this.openAccountDetails(item.accountId);
        // }
        else if(item.accountId){
          if(this.$route.params.reportid == 302 || this.$route.params.reportid == 402){
            let routeReportId = this.$route.params.reportid == 302 ? 301 : 401;
            // removing period from local storage before route update
            localStorage.removeItem('report_period_'+routeReportId);
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+routeReportId, query:{"isFilter":true, "filterPartyId":item.accountId, "filterPartyName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else if(this.$route.params.reportid == 504){
            if(!item.cols.isGroup){
              this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+505, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
            }
          }
          else if(this.$route.params.reportid == 605){
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+604, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else{
            // removing period from local storage before route update
            localStorage.removeItem('report_period_201');
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+201, query:{"itemId":item.accountId, "itemName":item.accountName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
        }
        else if(item.productId && this.$route.params.reportid != 108 && this.$route.params.reportid != 109 && this.$route.params.reportid != 309 && this.$route.params.reportid != 417 && this.$route.params.reportid != 104){
          // removing period from local storage before route update
          localStorage.removeItem('report_period_101');
          if(this.reportFilterObj.party){
            this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "isFilter":true, "filterPartyId":this.reportFilterObj.party.id, "filterPartyName":this.reportFilterObj.party.value, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
          }
          else{
            if(this.$route.params.reportid == 410){
              this.$router.push('/masters/inventory/productandservices/items/'+item.productId);
            }
            else{
              if(this.$route.params.reportid == 105){
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+106, query:{"itemId":item.productId, "itemName":item.productName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod, "itemId":item.cols.batchId, "itemName":item.cols.batchNumber ? item.productName + '/' + item.cols.batchNumber : item.productName}});  
              }
              else{
                this.$router.push({path:'/reports/'+this.$root.CurrentBusiness.BusinessID+'/'+101, query:{"itemId":item.productId, "itemName":item.productName, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
              }
            }
          }
        }
        else if(this.$route.params.reportid == 412 && item.expenseCategoryId){
          this.$router.push('/masters/expensecategory/items/'+item.expenseCategoryId);
        }
        else if((this.$route.params.reportid == 413 || this.$route.params.reportid == 414) && !item.accountId){
          let filterType = this.$route.params.reportid == 413 ? 2 : 3;
          this.$router.push({path:'/transactions/purchase/expense/items', query:{"tagId":this.guidWeb(), filterType:filterType, "startDate":startDate, "endDate":endDate, "selectedPeriod":this.propsObj.selectedPeriod}});
        }
        else if(this.$route.params.reportid == 104){
          this.fn_profitLossDetails(item);
        }
      },

      fn_profitLossDetails: function(data){
        this.$parent.$parent.itemWiseProfitLossData = data.cols;
        this.$parent.$parent.fn_openDialogWeb('web', 'ProfitLossDetails', 'ref_dialogProfitLossDetails');
      },

      fn_getCustomDateClass: function(item, col){
        if(this.$route.params.reportid == 109){
          if(Number(item.cols['expiredIn']) <= 0){
            return 'redcolor';
          }
        }
      }

    }
  }
</script>


// WEBPACK FOOTER //
// src/components/newreports/report_templates/general.vue